/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const Icon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <path d="M13,9.5 L14.5,9.5 L14.5,11.5 L17,9.5 L19,9.5 C21.485,9.5 23.5,7.485 23.5,5 C23.5,2.515 21.485,0.5 19,0.5 L13,0.5 C10.515,0.5 8.508,2.515 8.508,5" />
      <path d="M6,16.188 L6,18.37 L2.059,19.782 C1.115,20.117 0.5,21.011 0.5,22.012 L0.5,23.5 L15.5,23.5 L15.5,22.012 C15.5,21.011 14.885,20.117 13.941,19.782 L10,18.369 L10,16.047" />
      <ellipse cx="7.901" cy="12.052" rx="3.947" ry="4.737" />
      <path d="M11.828,11.625 C11.695,11.642 11.588,11.633 11.454,11.658 C10.109,11.917 9.246,11.429 8.506,10.135 C8.062,10.986 6.674,11.658 5.533,11.658 C4.971,11.658 4.476,11.555 3.992,11.302" />
      <polygon points="20 5 19 5 19 6 20 6" />
      <polygon points="17 5 16 5 16 6 17 6" />
      <polygon points="14 5 13 5 13 6 14 6" />
    </g>
  </svg>
);

export default Icon;
